export const organizationChartTranslation = {
  actions: {
    createSimulation: 'New simulation',
    goToManageStructures: 'Go to structure management',
  },
  buttons: {
    search: 'Search Node',
  },
  currentStructure: {
    organizational: 'Current Organizational Structure',
    personal: 'Current Personal Structure',
  },
  emptyState: {
    noSimulationSelected: {
      description: 'Pick a simulation under "Manage Structures" to see it on the tree.',
      title: 'No simulation selected',
    },
    unavailable: {
      chart: 'The tree view is temporarily unavailable. Please try again in a moment.',
      management: 'Simulation management is temporarily unavailable. Please try again in a moment.',
      modal: 'The create simulation dialog is temporarily unavailable.',
      nested: 'The nested view is temporarily unavailable. Please try again in a moment.',
    },
  },
  header: {
    subtitle: {
      current: 'The live organizational structure — read only.',
      simulations: 'Build and edit structure simulations without touching production data.',
    },
  },
  manageStructures: {
    description: 'Go to "Manage Structures" tab to display and select a structure.',
    selectStructure: 'Select Structure',
    title: 'Manage Structures',
  },
  simulationBadge: 'Simulation',
  structureType: {
    organizational: 'Organizational',
    personal: 'Personal',
  },
  tabs: {
    currentStructures: 'Current Structures',
    manageStructures: 'Manage Structures',
    nestedStructure: 'Nested Structure',
    simulationStructures: 'Structure Simulations',
    treeStructure: 'Tree Structure',
  },
};
